import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AlertsModal from 'components/Alerts/AlertsModal';

import {
  getShowAlertsModal,
  getShowNewAlertNotification,
  setAletsData,
  setShowAlertsModal,
  setShowNewAlertNotification,
} from 'store/alerts';
import { useAlerts, useSnackbar } from 'hooks';

import type { AlertValues } from './models/alert';

const data: AlertValues[] = [
  /* {
    id: 1,
    description: 'Cumpleaños de Abel Rodrigo Vazquez Abascal',
    eventType: 'Cumpleaños',
    isSelected: false,
    viewed: false,
  },
  {
    id: 2,
    description:
      'EZRA BEJAR Y ROSANES | Retiros fuera de los parámetros establecidos | 07/11/23',
    eventType: 'Rebalanceo',
    isSelected: false,
    viewed: false,
  }, */
];

const Alerts = () => {
  const dispatch = useDispatch();
  const showAlertsModal = useSelector(getShowAlertsModal);
  const showNewAlertNotification = useSelector(getShowNewAlertNotification);
  const { showSnackbarInfo } = useSnackbar();
  const { loadAlertsData } = useAlerts();

  const handleClose = () => {
    dispatch(setShowAlertsModal(false));
  };

  useEffect(() => {
    if (showNewAlertNotification) {
      showSnackbarInfo('Tiene una nueva notificación en Alertas');
      dispatch(setShowNewAlertNotification(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNewAlertNotification]);

  useEffect(() => {
    loadAlertsData();
    dispatch(setAletsData(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!showAlertsModal) {
    return <></>;
  }
  return <AlertsModal open={showAlertsModal} handleClose={handleClose} />;
};

export default Alerts;
